import * as _ from 'lodash';
import { ADD_MANAGERS, SET_MANAGERS_LOADING } from '@Actions/managersAction';
export const defaultState = {
    managers: [],
    managersLoading: false
};
export default function (state = defaultState, action) {
    switch (action.type) {
        case ADD_MANAGERS:
            return _.assign({}, state, {
                managers: _.uniqBy([...action.payload, ...state.managers], (manager) => manager.id)
            });
        case SET_MANAGERS_LOADING:
            return Object.assign(Object.assign({}, state), { managersLoading: action.payload });
        default:
            return state;
    }
}
